import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';


class OtherPassanger extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const { data } = this.props;
        return (
            <div className="flight-info row">
                <h1>
                    Other Passenger
                </h1>
                <table className="table table-stripped">
                    <thead>
                        <tr>
                            <td>#</td>
                            <td>First Name</td>
                            <td>Last Name</td>
                            <td>Nationality</td>
                            <td>Gender</td>
                            <td>Age</td>
                            <td>Remarks</td>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan={7} style={{ textAlign: 'center' }}>
                                    No Record Found
                                </td>
                            </tr>
                        ) : null}
                        {data.map((record, index) => (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{record.Full_Name__c}</td>
                                <td>{record.Last_Name__c}</td>
                                <td>{record.Nationality__c}</td>
                                <td>{record.Gender__c}</td>
                                <td>
                                    {record.Date_of_Birth__c
                                        ? moment().diff(
                                            record.Date_of_Birth__c,
                                            'years'
                                        )
                                        : '-'}
                                </td>
                                <td>{record.Remarks__c}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

OtherPassanger.propTypes = {
    data: PropTypes.array.isRequired,
};

export default OtherPassanger;
